import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Input, Tooltip, Form, Modal, Select, Space } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import {
  createFormApi,
  deleteFormApi,
  getAllFormsApi,
  getFormByIdApi,
  updateFormApi,
} from "../../../api/formsColaboradoresForms";
import { reducerRegister } from "../../../helpers/reducers";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

const rules = {
  descricao: [{ required: true, message: "Digite a descrição!" }],
  observacoes: [{ required: true, message: "Digite a observação!" }],
  status: [{ required: true, message: "Selecione o status!" }],
};

export const FormulariosColaboradoresCadFormularios = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    getAllForms();
  }, []);

  const getAllForms = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllFormsApi();
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createForm = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await createFormApi(data);
      if (statusCode === 200) {
        message.success("Registro cadastrado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "ADD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const updateForm = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await updateFormApi(data);
      if (statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "UPDATE", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getFormById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getFormByIdApi(id);
      if (statusCode === 200) {
        setShowModal(true);
        form.setFieldsValue({
          descricao: response?.data?.descricao,
          observacoes: response?.data?.observacoes,
          status: response?.data?.status,
        });
        setIdAlt(response.data.id);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const deleteForm = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteFormApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Observações",
      dataIndex: "observacoes",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Perfil">
            <Button
              loading={loading}
              onClick={() => navigate(`/formularios-colaboradores/formularios/perfis/${e.id}`)}
              icon={<UserOutlined />}
            />
          </Tooltip>
          <Tooltip title="Grupos">
            <Button
              loading={loading}
              onClick={() => navigate(`/formularios-colaboradores/formularios/grupos/${e.id}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
          <Button loading={loading} onClick={() => getFormById(e.id)} icon={<EditOutlined />} />
          <Button
            danger
            loading={loading}
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deleteForm(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
    },
  ];

  const onSubmit = (formData) => {
    if (idAlt > 0) {
      formData.id = idAlt;
      updateForm(formData);
    } else {
      createForm(formData);
    }
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Formulário
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={rules.descricao}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="observacoes" label="Observações">
              <Input.TextArea size="large" disabled={loading} placeholder="Informe as observações" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rules.status}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Formulários Colaboradores" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Formulários"
              subtitle="Cadastro de formulários"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
